import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar = ({ onSearch }: SearchBarProps) => {
  const [query, setQuery] = useState('');
  const [suggestions] = useState([
    'Retail footfall analytics',
    'Traffic flow monitoring',
    'Security threat detection',
    'Customer behavior analysis',
    'Queue management',
    'License plate recognition'
  ]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleSearch = (value: string) => {
    setQuery(value);
    onSearch(value);
    setShowSuggestions(value.length > 0);
  };

  const handleSuggestionClick = (suggestion: string) => {
    setQuery(suggestion);
    onSearch(suggestion);
    setShowSuggestions(false);
  };

  return (
    <div className="relative">
      <div className="relative">
        <Input
          type="search"
          placeholder="Search solutions by name, feature, or use case..."
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          className="pl-12 pr-4"
        />
        <Icon
          name="Search"
          size={20}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary"
        />
      </div>

      {showSuggestions && query.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-card rounded-lg shadow-brand-lg border border-border z-10 max-h-64 overflow-y-auto">
          <div className="p-2">
            <p className="text-xs text-text-secondary px-3 py-2">Suggested searches</p>
            {suggestions
              .filter(s => s.toLowerCase().includes(query.toLowerCase()))
              .map((suggestion, index) => (
                <button
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion)}
                  className="w-full text-left px-3 py-2 hover:bg-muted rounded-md transition-colors duration-300 flex items-center gap-2"
                >
                  <Icon name="Search" size={16} className="text-text-secondary" />
                  <span className="text-sm text-foreground">{suggestion}</span>
                </button>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;